import React from "react";
import { AlertTriangle } from "lucide-react";

export default function ApprovalAttention({ attention = {} }) {
  if (!attention.required) return null;
  const blockers = attention.new_blocking_conflicts || [];
  return <div className="panel border border-amber-500/50 bg-amber-950/20 p-3" data-testid="approval-attention">
    <div className="flex items-start gap-2">
      <AlertTriangle size={16} className="text-amber-300 mt-0.5" />
      <div>
        <div className="text-sm text-amber-200">New blocking outcome since approval</div>
        <div className="text-xs text-slate-400 mt-1">
          The approval record is preserved. Review the current result; ordinary non-blocking edits do not require another approval.
        </div>
        {blockers.length > 0 && <div className="font-mono text-[10px] text-amber-300 mt-2">
          {blockers.map(item => item.code).filter(Boolean).join(" · ")}
        </div>}
      </div>
    </div>
  </div>;
}
